import DataSourceWidgetView from '../data-source-widget-view'
import SpeedometerConfig from './speedometer-config'
import Radial from 'scoreboard/components/gauge/radial'
import deviceType from 'scoreboard/components/device-type'
import template from './speedometer-view.hbs'
import _ from 'lodash'
import datasetWidgetDrilldown from '../dataset-widget-drilldown'

const SpeedometerView = DataSourceWidgetView.extend({
	className: 'widget speedometer has-drilldown',
	resizable: true,
	lockedAR: true,
	configClass: SpeedometerConfig,
	template: template,

	nonFetchProperties: DataSourceWidgetView.prototype.nonFetchProperties.concat(
		'showScore', 'showActual', 'thresholdMode', 'showOrganization', 'showPeriod'),

	section: 'scorecards',

	initialize: function () {
		DataSourceWidgetView.prototype.initialize.apply(this, arguments)

		if (deviceType.safari) {
			// #50421 after zoom, speedometer text in Safari is blurry; resolved
			// by re-rendering it
			this.listenTo(this.canvas, 'zoom', () => {
				this.render()
			})
		}
	},

	/**
	 * @override
	 */
	renderContent ({ datasetQueryResponse } = {}) {
		const data = this.model.relevantData()
		const opt = this.model.gaugeOptions({ datasetQueryResponse })

		if (this.radial) {
			this.radial.options = opt
		} else {
			this.radial = new Radial(opt)
			this.$('.speedometer-wrapper').prepend(this.radial.el)
		}

		this.radial.render()

		// Once the radial is done rendering, the height may have changed;
		// update the wob's height
		var svg = this.radial.$('svg').get(0)
		var ar =  svg.viewBox.baseVal.height / svg.viewBox.baseVal.width

		// Temporarily disabled lockedAR, since this widget has a locked aspect
		// ratio for resize handlers, but when drawing based on settings
		// changes, we want the height to grow and the width to stay locked
		this.model.wob.lockedAR = false
		this.model.wob.resize(null, this.model.wob.get('width') * ar)
		this.model.wob.lockedAR = true

		this.toggleEmptyState(data.error)

		this.readyForDisplayAndExport()
	},

	allowConfig: function () {
		// even if this is a template copy, we can still change the drilldown
		return true
	},

	resize: function () {
		// If the widget is resized, need to re-render the empty state, since it
		// uses absolute width/height
		this.toggleEmptyState(this.model.relevantData().error)
	},

	/**
	 * @override
	 */
	drilldown: datasetWidgetDrilldown,

	remove: function () {
		DataSourceWidgetView.prototype.remove.apply(this, arguments)
		this.radial && this.radial.remove()
	}
})

export default SpeedometerView

SpeedometerView.__filename__ = 'dashboards/widgets/speedometer/speedometer-view.js'
